export const API_KEY = "AIzaSyDd9qB7kFnTIDdNYchQic2Huf-j7yccnG4";
export const AUTH_DOMAIN = "livueria.firebaseapp.com";
export const DATABASE_URL = "https://livueria.firebaseio.com";
export const PROJECT_ID = "livueria";
export const STORAGE_BUCKET = "livueria.appspot.com";
export const MESSAGING_SENDER_ID = "72306195388";
export const APP_ID = "1:72306195388:web:92c8d69cbbbb38d51d89b9";
export const measurementId = "G-J9NHZ79TFR";
